'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Internet classification -specific API calls
var InternetClassificationService = exports.InternetClassificationService = function () {
    function InternetClassificationService(winresCloudService, localizationService) {
        _classCallCheck(this, InternetClassificationService);

        this.winresCloudService = winresCloudService;
        this.localizationService = localizationService;
    }

    //the main function to call here.


    _createClass(InternetClassificationService, [{
        key: 'loadInternetClassifications',
        value: function loadInternetClassifications() {
            var _this = this;

            this.destinations = [];
            return this.getInternetClassifications().then(function (internetClassifications) {
                _this.addLevelsToInternetClassifications(internetClassifications, 1);
                _this.addParentsToInternetClassifications(internetClassifications, null);
                _this.internetClassifications = _.map(internetClassifications, function (internetClassification) {
                    _this.setName(internetClassification);
                    internetClassification.Level = 1;
                    return internetClassification;
                });
                _.each(_this.internetClassifications, function (classification) {
                    classification.Code = _.trim(classification.Code);
                    _.each(classification.Children, function (child) {
                        _this.addToDestinations(child);
                    });
                });
                _this.types = internetClassifications.map(_.clone);
                return _this.types;
            });
        }

        //this function may be called directly if for some reason the raw data is needed somewhere

    }, {
        key: 'getInternetClassifications',
        value: function getInternetClassifications() {
            var cacheKey = 'internet-classifications';

            return this.winresCloudService.makeAuthenticatedRequest('GetInternetClassifications', null, null, null, cacheKey);
        }
    }, {
        key: 'loadInternetClassificationsWithTitle',
        value: function loadInternetClassificationsWithTitle(language) {
            return this.getInternetClassificationsWithTitle(language).then(function (internetClassifications) {
                _.map(internetClassifications, function (internetClassification, idx) {
                    internetClassification.Icon = internetClassification.Icon || idx + 1;
                });
                return internetClassifications;
            });
        }
    }, {
        key: 'getInternetClassificationsWithTitle',
        value: function getInternetClassificationsWithTitle(language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetInternetClassificationsWithTitle', {
                'Language': language
            });
        }
    }, {
        key: 'addLevelsToInternetClassifications',
        value: function addLevelsToInternetClassifications(internetClassifications, currentLevel) {
            var _this2 = this;

            _.each(internetClassifications, function (classification) {
                classification.Level = currentLevel;
                _this2.addLevelsToInternetClassifications(classification.Children, currentLevel + 1);
                if (classification.Children.length == 0) {
                    classification.Value = true;
                }
            });
        }

        // Sets Parent of each internet classification recursively. The parent
        // is needed when adding to search criteria, to make sure that the whole
        // trail of criteria is added.

    }, {
        key: 'addParentsToInternetClassifications',
        value: function addParentsToInternetClassifications(internetClassifications, currentParent) {
            var _this3 = this;

            if (currentParent) {
                // Do not create circular references, as not to cause an infinite loop
                // in angular.equals when watching.
                currentParent = _.clone(currentParent);
                delete currentParent.Children;
            }
            _.each(internetClassifications, function (classification) {
                classification.Parent = currentParent;
                _this3.addParentsToInternetClassifications(classification.Children, classification);
            });
        }
    }, {
        key: 'setName',
        value: function setName(elem) {
            var _this4 = this;

            switch (this.localizationService.getLanguage()) {
                case 'fi':
                    elem.Name = elem.NameFi;
                    break;
                case 'de':
                    elem.Name = elem.NameDe;
                    break;
                case 'en':
                    elem.Name = elem.NameEn;
                    break;
                case 'ru':
                    elem.Name = elem.NameRu;
                    break;
                case 'sv':
                    elem.Name = elem.NameSe;
                    break;
            }
            if (elem.Children) {
                _.each(elem.Children, function (child) {
                    _this4.setName(child);
                });
            }
        }
    }, {
        key: 'addToDestinations',
        value: function addToDestinations(elem) {
            var _this5 = this;

            elem.Code = _.trim(elem.Code);
            // Null in value means that do not display the checkbox.
            if (elem.Children.length > 0) {
                elem.Value = null;
            }
            // Only add the second evel of hiearchy in classifications to "destinations"
            if (elem.Level === 2) {
                this.destinations.push(elem);
                _.each(elem.Children, function (child) {
                    _this5.addToDestinations(child);
                });
            }
        }

        // here ends the functions that handle the loadInternetClassifications edits.

    }]);

    return InternetClassificationService;
}();

InternetClassificationService.$inject = ['winresCloudService', 'localizationService'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/internetClassificationService.js
// module id = 566
// module chunks = 2